import { cn } from '@sparklayer-io/spark-dash-ui/lib/styles';
import { Badge, Button, Card, ExternalLink, Heading, Pressable, Text } from '@ui/themed';
import { t } from 'i18next';
import type { PropsWithChildren } from 'react';
import { useHandlers } from '../../../../context/page-context';

export function AddonCard(
  props: PropsWithChildren<{
    title: string;
    imgSrc: string;
    alt?: string;
    price: string;
    learnMoreURL: string;
    intercomClass: string;
  }>,
) {
  const { navigationHandler } = useHandlers();

  return (
    <div className="flex-1 basis-75 flex-col">
      <Card hidePadding fullHeight>
        <Pressable
          onClick={() =>
            navigationHandler.navigate(props.learnMoreURL, { absolute: true, newTab: true })
          }
        >
          <img
            src={props.imgSrc}
            alt={props.alt ?? 'addon card image'}
            className="w-full min-w-0 object-contain object-center"
          />
        </Pressable>
        <div className="flex flex-col gap-2 px-5 py-4">
          <Heading level="h3" style="sm" weight="normal">
            {props.title}
          </Heading>
          <Text variant="secondary">
            {props.children}{' '}
            <ExternalLink link={props.learnMoreURL} showIcon>
              {t('links:learn_more')}
            </ExternalLink>
          </Text>
          <Badge>{props.price}</Badge>
          <span className={cn(props.intercomClass)}>
            <Button icon="chat" variant="secondary">
              {t('buttons:speak_to_team')}
            </Button>
          </span>
        </div>
      </Card>
    </div>
  );
}
